/**
 * Shared utility to decode base64-encoded environment configuration
 * injected by Docker at runtime.
 *
 * In production (Docker): Reads from window.__ENV_CONFIG__ (base64 encoded), decodes it at runtime
 * In development/tests (Vite): Falls back to import.meta.env
 */

declare global {
  interface Window {
    __ENV_CONFIG__?: string;
  }
}

export function createEnvConfig<TEnvConfig>(importMetaEnv: unknown): TEnvConfig {
  if (typeof window === 'undefined' || !window.__ENV_CONFIG__) {
    return importMetaEnv as TEnvConfig;
  }

  try {
    // Decode base64 string
    const decoded = atob(window.__ENV_CONFIG__);
    // Parse JSON
    const config = JSON.parse(decoded);
    return config as TEnvConfig;
  } catch (error) {
    console.error('Failed to decode __ENV_CONFIG__:', error);
    return importMetaEnv as TEnvConfig;
  }
}
